import { map } from 'rxjs/operators';
import { updateStock, updateWarehouse } from '../../../features/stock/redux/stockSlices';
import { StockDto, WarehouseDto } from '../../PricePrgClient';
import { hubListener, hubNotifier, signalROptions } from '../helpers';
import { notifyWarehouseUpdated } from '../signalrActions';
import { SignalrHub } from '../signalrTypes';

export const stockHub: SignalrHub = {
    hubName: 'stock hub',
    url: '/signalr/stockHub',
    autoReconnect: true,
    options: signalROptions
};

const stockHub$ = hubListener(stockHub, hub => {
    const stockUpdated$ = hub
        .on<{ updatedStock: StockDto[]; deletedStock: StockDto[] }>('StockUpdated')
        .pipe(map(updateStock));

    const warehouseUpdated$ = hub.on<WarehouseDto>('WarehouseUpdated').pipe(map(updateWarehouse.success));

    return [stockUpdated$, warehouseUpdated$];
});

const notifyWarehouseUpdated$ = hubNotifier(stockHub, notifyWarehouseUpdated, (hub, payload) =>
    hub.send('NotifyWarehouseUpdated', payload)
);

export default [stockHub$, notifyWarehouseUpdated$];
